import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import * as messageConstants from '../../shared/messages';

class KeyLengthModal extends Component {
  handleHide = () => {
    this.props.handleHideModalKeyLengthConfirmation();
  }
  handleConfirm = () => {
    this.props.handleConfirmKeyLength();
  }
  render() {
    const {showModalKeyLengthConfirmation, pendingKeyLength} = this.props;
    return (
        <div className="action-block">
          <Modal
              show={showModalKeyLengthConfirmation}
              onHide={this.handleHide}
              container={this}
              dialogClassName="new-idp-certificate-modal"
          >
            <Modal.Header className="new-idp-certificate-modal-header">
              <Modal.Title className="line-height-for-modal-title">
                <span className="question-sign-rectangle">
                  <span className="qmark"/>
                </span>
                <span className="new-idp-certificate-modal-header-text">{messageConstants.KEY_LENGTH_MODAL_HEADER}</span>
                <button className="entity-id-modal-close"
                        type="button"
                        onClick={this.handleHide}/>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="new-idp-certificate-modal-body">
              {pendingKeyLength === 2048 ? <div className="modal-text-item-top">
                    {messageConstants.KEY_LENGTH_MODAL_BODY_SECTION_2048}
                  </div> : ''}
              {pendingKeyLength === 4096 ? <div className="modal-text-item-top">
                    {messageConstants.KEY_LENGTH_MODAL_BODY_SECTION_4096}
                  </div> : ''}
            </Modal.Body>
            <Modal.Footer className="new-idp-certificate-modal-footer">
              <button
                  type="button"
                  className="btn btn-md cancel-use-new-idp-certificate-button"
                  onClick={this.handleHide}>
                {messageConstants.CLOSE_BUTTON}
              </button>
              <button
                  type="button"
                  className="btn btn-md btn-primary use-new-idp-certificate-button"
                  onClick={this.handleConfirm}
                  disabled={!pendingKeyLength}
              >
                {pendingKeyLength === 2048 ?
                  messageConstants.KEY_LENGTH_MODAL_CONFIRM_BUTTON_2048 : ''}
                {pendingKeyLength === 4096 ?
                  messageConstants.KEY_LENGTH_MODAL_CONFIRM_BUTTON_4096 : ''}
              </button>
            </Modal.Footer>
          </Modal>
        </div>
    );
  }
}

export default KeyLengthModal;
